import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {Batiment} from '../Models/Batiment';
import {cloneDeep} from "lodash";

@Component({
	selector: 'app-modal-scenario-nrj',
	templateUrl: './modal-scenario-nrj.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-scenario-nrj.component.less']
})
export class ModalScenarioNrjComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	scenarios: any = [];

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		this.getInfosInit();
	}

	getInfosInit() {
		// ==> On GET le JSON des Textes globaux
		this.app.dataToolsService.currentGlobalTexts.subscribe(object => {

			// ==> Si l'objet n'est pas encore défini dans les dataTools, alors on appele la fonction dans sharedTools pour remplir l'objet dans les dataTools
			if (!object)
				this.app.sharedToolsService.getGlobalTexts();

			this.globalTxt = object;

			// ==> On CALL les textes des modals
			this.app.sharedToolsService.getJSON('txtModals').subscribe(resp => {
				console.log("resp ==> ", resp);
				this.modalsTxt = cloneDeep(resp.scenarios);

				let modalData = JSON.parse(localStorage.getItem('modalOpen')!);
				this.scenarios = (modalData) ? modalData.data : [];
				console.log(this.scenarios);
			})
		});
	}

	onChangeSceSelected(_sce: any) {
		console.log(_sce);
	}


	onValidateScenario() {
		console.log('onValidateScenario : this.scenarios => ', this.scenarios);

		let batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
		let batSimId: any = (batiment) ? batiment.simulationId : null;
		let simId = +batSimId;

		this.app.apiToolsService.setParamsEnergetiques(this.scenarios, simId).subscribe((res: any) => {
			console.log('setParamsEnergetiques res => ', res);

			if (res?.Status == 'OK') {
				location.reload();
			}
		});
	}
}
